import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BarControllerChartOptions, ChartDataset } from 'chart.js';
import { ToastrService } from 'ngx-toastr';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(private toastController: ToastrService, private http: HttpClient) { }
  /*
   Ventana emergente
  */
  async presentToast(message, title, type, time) {
    let toast;
    switch (type) {
      case 'error':
        toast = await this.toastController.error(
          message,
          title,
          {
            timeOut: time
          }
        );
        break;
      case 'success':
        toast = await this.toastController.success(
          message,
          title,
          {
            timeOut: time
          }
        );
        break;
      default:
        break;
    }
  }

  getCountry(){
    let url = 'https://api.ipregistry.co/?key=tryout';
    return this.http.get(url).pipe(map((data: any) => {
      return data;
    }), catchError(this.handleError))
  }

  getGraphicsDataPlatform(names, element, is1entre100mil, barChartData?, barChartData2?) {
    let graphic1 = {...barChartData, WritableStream}
    let graphic2 = {...barChartData2, WritableStream}
    for (let index = 0; index < names.length; index++) {
      const element0 = names[index];
      switch (element0) {
        case 'spend':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(element.spend);
            graphic1[0].type = 'bar';
            graphic1[0].backgroundColor = '#434343';
            graphic1[0].borderColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(element.spend);
            graphic1[1].type = 'bar';
            graphic1[1].backgroundColor = 'green';
            graphic1[1].borderColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(element.spend);
            graphic2[0].type = 'bar';
            graphic2[0].backgroundColor = '#434343';
            graphic2[0].borderColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(element.spend);
            graphic2[1].type = 'bar';
            graphic2[1].backgroundColor = 'green';
            graphic2[1].borderColor = 'green';
          }
          break;
        case 'impressions':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(element.impressions);
            graphic1[0].type = 'bar';
            graphic1[0].backgroundColor = '#434343';
            graphic1[0].borderColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(element.impressions);
            graphic1[1].type = 'bar';
            graphic1[1].backgroundColor = 'green';
            graphic1[1].borderColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(element.impressions);
            graphic2[0].type = 'bar';
            graphic2[0].backgroundColor = '#434343';
            graphic2[0].borderColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(element.impressions);
            graphic2[1].type = 'bar';
            graphic2[1].backgroundColor = 'green';
            graphic2[1].borderColor = 'green';
          }
          break;
        case 'clicks':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(element.clicks);
            graphic1[0].type = 'bar';
            graphic1[0].backgroundColor = '#434343';
            graphic1[0].borderColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(element.clicks);
            graphic1[1].type = 'bar';
            graphic1[1].backgroundColor = 'green';
            graphic1[1].borderColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(element.clicks);
            graphic2[0].type = 'bar';
            graphic2[0].backgroundColor = '#434343';
            graphic2[0].borderColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(element.clicks);
            graphic2[1].type = 'bar';
            graphic2[1].backgroundColor = 'green';
            graphic2[1].borderColor = 'green';
          }
          break;
        case 'cpc':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(element.cpc);
            graphic1[0].type = 'bar';
            graphic1[0].borderColor = '#434343';
            graphic1[0].backgroundColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(element.cpc);
            graphic1[1].type = 'bar';
            graphic1[1].borderColor = 'green';
            graphic1[1].backgroundColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(element.cpc);
            graphic2[0].type = 'bar';
            graphic2[0].borderColor = '#434343';
            graphic2[0].backgroundColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(element.cpc);
            graphic2[1].type = 'bar';
            graphic2[1].borderColor = 'green';
            graphic2[1].backgroundColor = 'green';
          }
          break;
        case 'ctr':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(element.ctr);
            graphic1[0].type = 'bar';
            graphic1[0].borderColor = '#434343';
            graphic1[0].backgroundColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(element.ctr);
            graphic1[1].type = 'bar';
            graphic1[1].borderColor = 'green';
            graphic1[1].backgroundColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(element.ctr);
            graphic2[0].type = 'bar';
            graphic2[0].borderColor = '#434343';
            graphic2[0].backgroundColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(element.ctr);
            graphic2[1].type = 'bar';
            graphic2[1].borderColor = 'green';
            graphic2[1].backgroundColor = 'green';
          }
          break;
        case 'cust':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(Number(element.conversions));
            graphic1[0].type = 'bar';
            graphic1[0].backgroundColor = '#434343';
            graphic1[0].borderColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(Number(element.conversions));
            graphic1[1].type = 'bar';
            graphic1[1].backgroundColor = 'green';
            graphic1[1].borderColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(Number(element.conversions));
            graphic2[0].type = 'bar';
            graphic2[0].backgroundColor = '#434343';
            graphic2[0].borderColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(Number(element.conversions));
            graphic2[1].type = 'bar';
            graphic2[1].backgroundColor = 'green';
            graphic2[1].borderColor = 'green';
          }
          break;
        case 'cost/cust':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(Number(element.cost_per_conversion));
            graphic1[0].type = 'bar';
            graphic1[0].borderColor = '#434343';
            graphic1[0].backgroundColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(Number(element.cost_per_conversion));
            graphic1[1].type = 'bar';
            graphic1[1].borderColor = 'green';
            graphic1[1].backgroundColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(Number(element.cost_per_conversion));
            graphic2[0].type = 'bar';
            graphic2[0].borderColor = '#434343';
            graphic2[0].backgroundColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(Number(element.cost_per_conversion));
            graphic2[1].type = 'bar';
            graphic2[1].borderColor = 'green';
            graphic2[1].backgroundColor = 'green';
          }
          break;
        case 'leads':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(Number(element.leads));
            graphic1[0].type = 'bar';
            graphic1[0].backgroundColor = '#434343';
            graphic1[0].borderColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(Number(element.leads));
            graphic1[1].type = 'bar';
            graphic1[1].backgroundColor = 'green';
            graphic1[1].borderColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(Number(element.leads));
            graphic2[0].type = 'bar';
            graphic2[0].backgroundColor = '#434343';
            graphic2[0].borderColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(Number(element.leads));
            graphic2[1].type = 'bar';
            graphic2[1].backgroundColor = 'green';
            graphic2[1].borderColor = 'green';
          }
          break;
        case 'adq':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(Number(element.adquitision));
            graphic1[0].type = 'bar';
            graphic1[0].backgroundColor = '#434343';
            graphic1[0].borderColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(Number(element.adquitision));
            graphic1[1].type = 'bar';
            graphic1[1].backgroundColor = 'green';
            graphic1[1].borderColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(Number(element.adquitision));
            graphic2[0].type = 'bar';
            graphic2[0].backgroundColor = '#434343';
            graphic2[0].borderColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(Number(element.adquitision));
            graphic2[1].type = 'bar';
            graphic2[1].backgroundColor = 'green';
            graphic2[1].borderColor = 'green';
          }
          break;
        case 'cpl':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(Number(element.cost_per_leads));
            graphic1[0].type = 'bar';
            graphic1[0].borderColor = '#434343';
            graphic1[0].backgroundColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(Number(element.cost_per_leads));
            graphic1[1].type = 'bar';
            graphic1[1].borderColor = 'green';
            graphic1[1].backgroundColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(Number(element.cost_per_leads));
            graphic2[0].type = 'bar';
            graphic2[0].borderColor = '#434343';
            graphic2[0].backgroundColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(Number(element.cost_per_leads));
            graphic2[1].type = 'bar';
            graphic2[1].borderColor = 'green';
            graphic2[1].backgroundColor = 'green';
          }
          break;
        case 'cpa':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(Number(element.cost_per_adquisition));
            graphic1[0].type = 'bar';
            graphic1[0].borderColor = '#434343';
            graphic1[0].backgroundColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(Number(element.cost_per_adquisition));
            graphic1[1].type = 'bar';
            graphic1[1].borderColor = 'green';
            graphic1[1].backgroundColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(Number(element.cost_per_adquisition));
            graphic2[0].type = 'bar';
            graphic2[0].borderColor = '#434343';
            graphic2[0].backgroundColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(Number(element.cost_per_adquisition));
            graphic2[1].type = 'bar';
            graphic2[1].borderColor = 'green';
            graphic2[1].backgroundColor = 'green';
          }
          break;
        case 'conv':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(Number(element.conversions_leads));
            graphic1[0].type = 'bar';
            graphic1[0].backgroundColor = '#434343';
            graphic1[0].borderColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(Number(element.conversions_leads));
            graphic1[1].type = 'bar';
            graphic1[1].backgroundColor = 'green';
            graphic1[1].borderColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(Number(element.conversions_leads));
            graphic2[0].type = 'bar';
            graphic2[0].backgroundColor = '#434343';
            graphic2[0].borderColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(Number(element.conversions_leads));
            graphic2[1].type = 'bar';
            graphic2[1].backgroundColor = 'green';
            graphic2[1].borderColor = 'green';
          }
          break;
        case 'cost/conv':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(Number(element.cost_conversions_leads));
            graphic1[0].type = 'bar';
            graphic1[0].borderColor = '#434343';
            graphic1[0].backgroundColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(Number(element.cost_conversions_leads));
            graphic1[1].type = 'bar';
            graphic1[1].borderColor = 'green';
            graphic1[1].backgroundColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(Number(element.cost_conversions_leads));
            graphic2[0].type = 'bar';
            graphic2[0].borderColor = '#434343';
            graphic2[0].backgroundColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(Number(element.cost_conversions_leads));
            graphic2[1].type = 'bar';
            graphic2[1].borderColor = 'green';
            graphic2[1].backgroundColor = 'green';
          }
          break;
        case 'leads/clicks':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(Number(element.rlc));
            graphic1[0].type = 'bar';
            graphic1[0].borderColor = '#434343';
            graphic1[0].backgroundColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(Number(element.rlc));
            graphic1[1].type = 'bar';
            graphic1[1].borderColor = 'green';
            graphic1[1].backgroundColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(Number(element.rlc));
            graphic2[0].type = 'bar';
            graphic2[0].borderColor = '#434343';
            graphic2[0].backgroundColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(Number(element.rlc));
            graphic2[1].type = 'bar';
            graphic2[1].borderColor = 'green';
            graphic2[1].backgroundColor = 'green';
          }
          break;
        case 'adq/clicks':
          if (index == 0 && barChartData != undefined) {
            graphic1[0].data.push(Number(element.rac));
            graphic1[0].type = 'bar';
            graphic1[0].borderColor = '#434343';
            graphic1[0].backgroundColor = '#434343';
          } else if (index == 1 && barChartData != undefined) {
            graphic1[1].data.push(Number(element.rac));
            graphic1[1].type = 'bar';
            graphic1[1].borderColor = 'green';
            graphic1[1].backgroundColor = 'green';
          } else if (index == 2 && barChartData2 != undefined) {
            graphic2[0].data.push(Number(element.rac));
            graphic2[0].type = 'bar';
            graphic2[0].borderColor = '#434343';
            graphic2[0].backgroundColor = '#434343';
          } else if (index == 3 && barChartData2 != undefined) {
            graphic2[1].data.push(Number(element.rac));
            graphic2[1].type = 'bar';
            graphic2[1].borderColor = 'green';
            graphic2[1].backgroundColor = 'green';
          }
          break;
        case 'conv/clicks':
          if (is1entre100mil) {
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.cac));
              graphic1[0].type = 'bar';
              graphic1[0].borderColor = '#434343';
              graphic1[0].backgroundColor = '#434343';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.cac));
              graphic1[1].type = 'bar';
              graphic1[1].borderColor = 'green';
              graphic1[1].backgroundColor = 'green';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.cac));
              graphic2[0].type = 'bar';
              graphic2[0].borderColor = '#434343';
              graphic2[0].backgroundColor = '#434343';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.cac));
              graphic2[1].type = 'bar';
              graphic2[1].borderColor = 'green';
              graphic2[1].backgroundColor = 'green';
            }
          } else {
            if (index == 0 && graphic1 != undefined) {
              graphic1[0].data.push(Number(element.clc));
              graphic1[0].type = 'bar';
              graphic1[0].borderColor = '#434343';
              graphic1[0].backgroundColor = '#434343';
            } else if (index == 1 && graphic1 != undefined) {
              graphic1[1].data.push(Number(element.clc));
              graphic1[1].type = 'bar';
              graphic1[1].borderColor = 'green';
              graphic1[1].backgroundColor = 'green';
            } else if (index == 2 && graphic2 != undefined) {
              graphic2[0].data.push(Number(element.clc));
              graphic2[0].type = 'bar';
              graphic2[0].borderColor = '#434343';
              graphic2[0].backgroundColor = '#434343';
            } else if (index == 3 && graphic2 != undefined) {
              graphic2[1].data.push(Number(element.clc));
              graphic2[1].type = 'bar';
              graphic2[1].borderColor = 'green';
              graphic2[1].backgroundColor = 'green';
            }
          }
          break;
        default:
          break;
      }
      barChartData = {...graphic1};
      barChartData2 = {...graphic2};
    }
    barChartData = {...graphic1};
    barChartData2 = {...graphic2}
  }

    /*
    Dependiendo la métrica a mostrar, se usará un estilo de barra u otro
  */
    getGraphicsData(names, element, is1entre100mil, barChartData?, barChartData2?, color1?, color2?) {
      let graphic1 = {...barChartData, WritableStream}
      let graphic2 = {...barChartData2, WritableStream}
      for (let index = 0; index < names.length; index++) {
        const element0 = names[index];
        switch (element0) {
          case 'spend':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.spend));
              graphic1[0].type = 'bar';
              graphic1[0].backgroundColor = '#434343';
              graphic1[0].borderColor = '#434343';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.spend));
              graphic1[1].type = 'bar';
              graphic1[1].backgroundColor = 'green';
              graphic1[1].borderColor = 'green';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.spend));
              graphic2[0].type = 'bar';
              graphic2[0].backgroundColor = '#434343';
              graphic2[0].borderColor = '#434343';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.spend));
              graphic2[1].type = 'bar';
              graphic2[1].backgroundColor = 'green';
              graphic2[1].borderColor = 'green';
            }
            break;
          case 'impressions':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.impressions));
              graphic1[0].type = 'bar';
              graphic1[0].backgroundColor = '#434343';
              graphic1[0].borderColor = '#434343';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.impressions));
              graphic1[1].type = 'bar';
              graphic1[1].backgroundColor = 'green';
              graphic1[1].borderColor = 'green';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.impressions));
              graphic2[0].type = 'bar';
              graphic2[0].backgroundColor = '#434343';
              graphic2[0].borderColor = '#434343';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.impressions));
              graphic2[1].type = 'bar';
              graphic2[1].backgroundColor = 'green';
              graphic2[1].borderColor = 'green';
            }
            break;
          case 'clicks':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.clicks));
              graphic1[0].type = 'bar';
              graphic1[0].backgroundColor = '#434343';
              graphic1[0].borderColor = '#434343';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.clicks));
              graphic1[1].type = 'bar';
              graphic1[1].backgroundColor = 'green';
              graphic1[1].borderColor = 'green';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.clicks));
              graphic2[0].type = 'bar';
              graphic2[0].backgroundColor = '#434343';
              graphic2[0].borderColor = '#434343';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.clicks));
              graphic2[1].type = 'bar';
              graphic2[1].backgroundColor = 'green';
              graphic2[1].borderColor = 'green';
            }
            break;
          case 'cpc':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.cpc));
              graphic1[0].type = 'line';
              graphic1[0].borderColor = '#434343';
              graphic1[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.cpc));
              graphic1[1].type = 'line';
              graphic1[1].borderColor = 'green';
              graphic1[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.cpc));
              graphic2[0].type = 'line';
              graphic2[0].borderColor = '#434343';
              graphic2[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.cpc));
              graphic2[1].type = 'line';
              graphic2[1].borderColor = 'green';
              graphic2[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            }
            break;
          case 'ctr':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.ctr));
              graphic1[0].type = 'line';
              graphic1[0].borderColor = '#434343';
              graphic1[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.ctr));
              graphic1[1].type = 'line';
              graphic1[1].borderColor = 'green';
              graphic1[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.ctr));
              graphic2[0].type = 'line';
              graphic2[0].borderColor = '#434343';
              graphic2[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.ctr));
              graphic2[1].type = 'line';
              graphic2[1].borderColor = 'green';
              graphic2[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            }
            break;
          case 'cust':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.conversions));
              graphic1[0].type = 'bar';
              graphic1[0].backgroundColor = '#434343';
              graphic1[0].borderColor = '#434343';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.conversions));
              graphic1[1].type = 'bar';
              graphic1[1].backgroundColor = 'green';
              graphic1[1].borderColor = 'green';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.conversions));
              graphic2[0].type = 'bar';
              graphic2[0].backgroundColor = '#434343';
              graphic2[0].borderColor = '#434343';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.conversions));
              graphic2[1].type = 'bar';
              graphic2[1].backgroundColor = 'green';
              graphic2[1].borderColor = 'green';
            }
            break;
          case 'cost/cust':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.cost_per_conversion));
              graphic1[0].type = 'line';
              graphic1[0].borderColor = '#434343';
              graphic1[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.cost_per_conversion));
              graphic1[1].type = 'line';
              graphic1[1].borderColor = 'green';
              graphic1[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.cost_per_conversion));
              graphic2[0].type = 'line';
              graphic2[0].borderColor = '#434343';
              graphic2[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.cost_per_conversion));
              graphic2[1].type = 'line';
              graphic2[1].borderColor = 'green';
              graphic2[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            }
            break;
          case 'leads':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.leads));
              graphic1[0].type = 'bar';
              graphic1[0].backgroundColor = '#434343';
              graphic1[0].borderColor = '#434343';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.leads));
              graphic1[1].type = 'bar';
              graphic1[1].backgroundColor = 'green';
              graphic1[1].borderColor = 'green';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.leads));
              graphic2[0].type = 'bar';
              graphic2[0].backgroundColor = '#434343';
              graphic2[0].borderColor = '#434343';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.leads));
              graphic2[1].type = 'bar';
              graphic2[1].backgroundColor = 'green';
              graphic2[1].borderColor = 'green';
            }
            break;
          case 'adq':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.adquitision));
              graphic1[0].type = 'bar';
              graphic1[0].backgroundColor = '#434343';
              graphic1[0].borderColor = '#434343';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.adquitision));
              graphic1[1].type = 'bar';
              graphic1[1].backgroundColor = 'green';
              graphic1[1].borderColor = 'green';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.adquitision));
              graphic2[0].type = 'bar';
              graphic2[0].backgroundColor = '#434343';
              graphic2[0].borderColor = '#434343';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.adquitision));
              graphic2[1].type = 'bar';
              graphic2[1].backgroundColor = 'green';
              graphic2[1].borderColor = 'green';
            }
            break;
          case 'cpl':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.cost_per_leads));
              graphic1[0].type = 'line';
              graphic1[0].borderColor = '#434343';
              graphic1[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.cost_per_leads));
              graphic1[1].type = 'line';
              graphic1[1].borderColor = 'green';
              graphic1[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.cost_per_leads));
              graphic2[0].type = 'line';
              graphic2[0].borderColor = '#434343';
              graphic2[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.cost_per_leads));
              graphic2[1].type = 'line';
              graphic2[1].borderColor = 'green';
              graphic2[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            }
            break;
          case 'cpa':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.cost_per_adquisition));
              graphic1[0].type = 'line';
              graphic1[0].borderColor = '#434343';
              graphic1[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.cost_per_adquisition));
              graphic1[1].type = 'line';
              graphic1[1].borderColor = 'green';
              graphic1[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.cost_per_adquisition));
              graphic2[0].type = 'line';
              graphic2[0].borderColor = '#434343';
              graphic2[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.cost_per_adquisition));
              graphic2[1].type = 'line';
              graphic2[1].borderColor = 'green';
              graphic2[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            }
            break;
          case 'conv':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.conversions_leads));
              graphic1[0].type = 'bar';
              graphic1[0].backgroundColor = '#434343';
              graphic1[0].borderColor = '#434343';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.conversions_leads));
              graphic1[1].type = 'bar';
              graphic1[1].backgroundColor = 'green';
              graphic1[1].borderColor = 'green';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.conversions_leads));
              graphic2[0].type = 'bar';
              graphic2[0].backgroundColor = '#434343';
              graphic2[0].borderColor = '#434343';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.conversions_leads));
              graphic2[1].type = 'bar';
              graphic2[1].backgroundColor = 'green';
              graphic2[1].borderColor = 'green';
            }
            break;
          case 'cost/conv':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.cost_conversions_leads));
              graphic1[0].type = 'line';
              graphic1[0].borderColor = '#434343';
              graphic1[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.cost_conversions_leads));
              graphic1[1].type = 'line';
              graphic1[1].borderColor = 'green';
              graphic1[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.cost_conversions_leads));
              graphic2[0].type = 'line';
              graphic2[0].borderColor = '#434343';
              graphic2[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.cost_conversions_leads));
              graphic2[1].type = 'line';
              graphic2[1].borderColor = 'green';
              graphic2[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            }
            break;
          case 'leads/clicks':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.pus(Number(element.rlc));
              graphic1[0].type = 'line';
              graphic1[0].borderColor = '#434343';
              graphic1[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.rlc));
              graphic1[1].type = 'line';
              graphic1[1].borderColor = 'green';
              graphic1[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.rlc));
              graphic2[0].type = 'line';
              graphic2[0].borderColor = '#434343';
              graphic2[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.rlc));
              graphic2[1].type = 'line';
              graphic2[1].borderColor = 'green';
              graphic2[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            }
            break;
          case 'adq/clicks':
            if (index == 0 && barChartData != undefined) {
              graphic1[0].data.push(Number(element.rac));
              graphic1[0].type = 'line';
              graphic1[0].borderColor = '#434343';
              graphic1[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 1 && barChartData != undefined) {
              graphic1[1].data.push(Number(element.rac));
              graphic1[1].type = 'line';
              graphic1[1].borderColor = 'green';
              graphic1[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 2 && barChartData2 != undefined) {
              graphic2[0].data.push(Number(element.rac));
              graphic2[0].type = 'line';
              graphic2[0].borderColor = '#434343';
              graphic2[0].backgroundColor = 'rgba(255, 255, 255, 0)';
            } else if (index == 3 && barChartData2 != undefined) {
              graphic2[1].data.push(Number(element.rac));
              graphic2[1].type = 'line';
              graphic2[1].borderColor = 'green';
              graphic2[1].backgroundColor = 'rgba(255, 255, 255, 0)';
            }
            break;
          case 'conv/clicks':
            if (is1entre100mil) {
              if (index == 0 && barChartData != undefined) {
                graphic1[0].data.push(Number(element.cac));
                graphic1[0].type = 'line';
                graphic1[0].borderColor = '#434343';
                graphic1[0].backgroundColor = 'rgba(255, 255, 255, 0)';
              } else if (index == 1 && barChartData != undefined) {
                graphic1[1].data.push(Number(element.cac));
                graphic1[1].type = 'line';
                graphic1[1].borderColor = 'green';
                graphic1[1].backgroundColor = 'rgba(255, 255, 255, 0)';
              } else if (index == 2 && barChartData2 != undefined) {
                graphic2[0].data.push(Number(element.cac));
                graphic2[0].type = 'line';
                graphic2[0].borderColor = '#434343';
                graphic2[0].backgroundColor = 'rgba(255, 255, 255, 0)';
              } else if (index == 3 && barChartData2 != undefined) {
                graphic2[0].data.push(Number(element.cac));
                graphic2[0].type = 'line';
                graphic2[1].borderColor = 'green';
                graphic2[1].backgroundColor = 'rgba(255, 255, 255, 0)';
              }
            } else {
              if (index == 0 && graphic1 != undefined) {
                graphic1[0].data.push(Number(element.clc));
                graphic1[0].type = 'line';
                graphic1[0].borderColor = '#434343';
                graphic1[0].backgroundColor = 'rgba(255, 255, 255, 0)';
              } else if (index == 1 && graphic1 != undefined) {
                graphic1[1].data.push(Number(element.clc));
                graphic1[1].type = 'line';
                graphic1[1].borderColor = 'green';
                graphic1[1].backgroundColor = 'rgba(255, 255, 255, 0)';
              } else if (index == 2 && graphic2 != undefined) {
                graphic2[0].data.push(Number(element.clc));
                graphic2[0].type = 'line';
                graphic2[0].borderColor = '#434343';
                graphic2[0].backgroundColor = 'rgba(255, 255, 255, 0)';
              } else if (index == 3 && graphic2 != undefined) {
                graphic2[1].data.push(Number(element.clc));
                graphic2[1].type = 'line';
                graphic2[1].borderColor = 'green';
                graphic2[1].backgroundColor = 'rgba(255, 255, 255, 0)';
              }
            }
            break;
          default:
            break;
        }
      }
      barChartData = {...graphic1};
      barChartData2 = {...graphic2}
    }

    handleError(error: HttpErrorResponse) {
      let errorMessage = 'Unknown error!';
      if (error.error instanceof ErrorEvent) {
        // Client-side errors
        errorMessage = `Error: ${error.error.message}`;
      } else {
        // Server-side errors
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      return throwError(errorMessage);
    }

}
